import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useForm } from 'antd/lib/form/Form';
import { ApplicantStatusesEnum } from '@thinknet-gmbh/platform-common';
import {
  Button,
  ButtonsWrapper,
  Form,
  Loader,
  PageLayout,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';
import { useRouteQuery } from 'src/common/helpers';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { useGetCurrentCompany } from 'src/hooks/companies/get-current-company.hook';
import { useCreateEmployee } from 'src/hooks/employees/create-employee.hook';
import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useGetApplicantById } from 'src/hooks/applicants/get-applicant-by-id.hook';
import { useUpdateApplicantById } from 'src/hooks/applicants/update-applicant-by-id.hook';


import { PersonalInfo } from 'src/components/employee/personal-info';
import { CreateEmployeeWrapper } from './create-employee.styles';

const CreateEmployee = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(['common', 'employee']);
  const [form] = useForm();
  const query = useRouteQuery();
  const applicantId = query.get('applicantId') || '';

  const { applicant, loading } = useGetApplicantById(applicantId);
  const { updateApplicant } = useUpdateApplicantById({});
  const currentCompanyId = useGetCurrentCompanyId();
  const { company } = useGetCurrentCompany();
  const { createEmployee } = useCreateEmployee({
    onSuccess: () => navigate(ROUTES.employee),
  });

  const onFinish = (values: any) => {
    const { name, street, city, zipCode, country, houseNumber } = company;

    createEmployee({
      variables: {
        payload: {
          ...values,
          permissionGroupId: values.employeePersonalInfo.accessToPlatform
            ? values.permissionGroupId
            : undefined,
          companyId: currentCompanyId,
          ownerCompany: {
            name,
            city,
            country,
            zipCode,
            street,
            houseNumber,
          },
        },
      },
      onCompleted: () => {
        if (applicantId) {
          updateApplicant({
            variables: { applicantId, payload: { status: ApplicantStatusesEnum.HIRED } },
          });
        }
      },
    });
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <PageLayout pageTitle="Add new employee">
      <CreateEmployeeWrapper>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('employee:labels.employeeProfile')}
        </Typography>
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          scrollToFirstError
          initialValues={applicantId ? applicant : undefined}
        >
          <PersonalInfo />
          <ButtonsWrapper marginTop={16}>
            <Button type="primary" htmlType="submit">
              {t('common:buttons.save')}
            </Button>
            <Button onClick={() => navigate(ROUTES.employee)}>{t('common:buttons.cancel')}</Button>
          </ButtonsWrapper>
        </Form>
      </CreateEmployeeWrapper>
    </PageLayout>
  );
};

export default CreateEmployee;
